import React, { useState } from "react";
import { gsap } from "gsap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import { db } from "../../../firebase";
import "./css/style.css";
import { query, getDocs, collection } from "firebase/firestore";

const Movieshome = () => {
  const [moviedata, setMoviedata] = useState([]);

  React.useEffect(() => {
    const fetchMovies = async () => {
      try {
        const q = query(collection(db, 'movie'));
        const querySnapshot = await getDocs(q);
        let movies = querySnapshot.docs.map(doc => ({
          id: doc.id,
          createTime: new Date(doc._document.createTime.timestamp.seconds * 1000), // Convert to Date object
          ...doc.data()
        }));
  
        // Sort descending by createTime
        movies.sort((a, b) => b.createTime - a.createTime);
  
        setMoviedata(movies);
      } catch (error) {
        console.error("Error fetching movies:", error);
      }
    };
  
    fetchMovies();
  }, []);

  const [swiper, setSwiper] = useState(null);

  const slideNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const slidePrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const slideTo = (index) => {
    if (swiper !== null) {
      swiper.slideTo(index);
    }
  };

  const onSwiper = (swiper) => {
    setSwiper(swiper);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col sm="12" className="overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="all-movies-title">All Movies</h4>
              <Link
                className="all-movies-view"
                to="/movies"
                style={{ fontWeight: "400" }}
              >
                View All
              </Link>
            </div>
            <div id="favorites-contens">
              <div id="prev2" className="swiper-button swiper-button-prev">
                <i className="fa fa-chevron-left"></i>
              </div>
              <div id="next2" className="swiper-button swiper-button-next">
                <i className="fa fa-chevron-right"></i>
              </div>
              <Swiper
                navigation={{
                  prevEl: "#prev2",
                  nextEl: "#next2",
                }}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  550: { slidesPerView: 3 },
                  991: { slidesPerView: 5 },
                  1400: { slidesPerView: 6 },
                }}
                key={`swiper-${moviedata.length}`}
                loop={true}
                slidesPerView={4}
                spaceBetween={20}
                as="ul"
                className="favorites-slider list-inline  row p-0 m-0 iq-rtl-direction"
              >
                {moviedata.map((data, index) => (
                  <SwiperSlide key={data.id} as="li">
                    <div className="block-images position-relative">
                      <div className="movie-thumb-new">
                        <img
                          src={data.thumbnail}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="block-description">
                        <h6 className="iq-title" style={{ fontSize: "14px" }}>
                          <Link to="/show-details">{data.movie_title}</Link>
                          &nbsp;({data.language})
                        </h6>
                        <div
                          className="movie-time d-flex align-items-center my-2 iq-ltr-direction"
                          style={{ fontSize: "20px", opacity: ".8" }}
                        >
                          <span
                            className="badge badge-secondary p-0 mx-0"
                            style={{
                              backgroundColor: "#3e536600",
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            {data.genres}
                          </span>
                        </div>
                        <div className="hover-buttons">
                          <a
                            href={`/movie/${data.slug}`}
                            role="button"
                            className="btn btn-hover iq-button"
                            style={{ fontWeight: 500 }}
                          >
                            View
                          </a>
                        </div>
                      </div>
                      <div className="block-social-info">
                        <ul className="list-inline p-0 m-0 music-play-lists">
                          <li className="share">
                            <span>
                              <i className="ri-share-fill"></i>
                            </span>
                            <div className="share-box">
                              <div className="d-flex align-items-center">
                                <Link
                                  to={
                                    "//www.facebook.com/sharer?u=" +
                                    window.location.href
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="share-ico"
                                  tabIndex="0"
                                >
                                  <i className="ri-facebook-fill"></i>
                                </Link>
                                <Link
                                  to={
                                    "//twitter.com/intent/tweet?text=" +
                                    window.location.href
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="share-ico"
                                  tabIndex="0"
                                >
                                  <i className="ri-twitter-fill"></i>
                                </Link>
                                <Link
                                  to="#"
                                  data-link="https://iqonic.design/wp-themes/streamit_wp/movie/shadow/"
                                  className="share-ico iq-copy-link"
                                  tabIndex="0"
                                >
                                  <i className="ri-links-fill"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                          {/* <li>
                                             <span><i className="ri-heart-fill"></i></span>
                                             <span className="count-box">19+</span>
                                          </li>
                                          <li>
                                             <span><i className="ri-add-line"></i></span>
                                </li> */}
                        </ul>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Movieshome;
